import React, { useCallback, useEffect } from 'react';
import '../style/about.css';
import { Container, Row, Col } from 'react-bootstrap';
import thankyou from '../assets/thankyou.png';

const Close = () => {
  const onClose = useCallback(() => {
    if (window && window.parent) {
      console.log('Sending close-window message to parent');
      // window.ReactNativeWebView.postMessage('close-window');
      // window.parent.postMessage({ type: 'close-window' }, '*');
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'close-window' }));
    }
  }, []);

  useEffect(() => {
    onClose();
  }, [onClose]);

  return (
    <div>
      <section className="thankyoubanner" >
        <Container>
          <Row>
            <Col md={12}>
              {/* <img src={thankyou} /> */}
              Thanks for your order, you can close this window now.<br />
              <br />
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#007bff',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit'
                }}
                onClick={onClose}
              >
                Close Window
              </button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};


export default Close;
